module.exports = __webpack_public_path__ + "static/media/993979.a8840e8c.png";